import React, { useState, useEffect, Fragment } from "react";
import DashboardLine from "./line";
import { connect } from "react-redux";
import MainTemplate from "../mainTemplate/";
import PieChart from "../../public/dashboard/pieChart";
import BlankProviderBill from "../bills/blankProviderBill";
import Transactions from "../../public/dashboard/transactions";
import { getEmptyBills } from "../../../Redux/reducer/credit-line";
import useApi from "../../hooks/useApi";
import { useTranslation } from "react-i18next";

import { ReactTitle } from "react-meta-tags";
import PendingAccountsAlert from "./PendingAccountsAlert";
import { moduleAction } from "../../utils/functions";
import { EXECUTE, MOD_RELATIONS } from "../../../permissions";
import { getRoles } from "../../../Redux/reducer/session";
import Disclaimer from "../../shared/Disclaimer/Disclaimer";

const DashboardProvider = (props) => {
  const [ready, setReady] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const { getApiCAll } = useApi();
  const { t } = useTranslation();

  useEffect(() => {
    const pendingAccounts = async () => {
      const url = "/providers/additions-modifications-Accouts?page=0&size=10";
      try {
        const response = await getApiCAll(url);
        setTotalElements(response.data.data.totalElements);
      } finally {
        setReady(true);
      }
    };

    const executePermission = moduleAction(props.roles, MOD_RELATIONS, EXECUTE)

    if(executePermission) {
      pendingAccounts();
    }else{
      setReady(true);
    }
    
  }, []);

  const loadingPendingAccountAlert = () => {
    return (
      <div className="linear-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
  };

  return (
    <MainTemplate className="wrapper-dashboard">
      <ReactTitle title={`Dashboard - Reverse Factoring`} />
      <Disclaimer containerClass={"full-width"}>
        <p className="one-line">{t("disclaimer.text")}</p>
      </Disclaimer>
      <DashboardLine />
      <div
        className={`components ${
          totalElements !== 0 ? "dashboard-empty-bill" : ""
        }`}
      >
        {props.emptyBills === true ? (
          <>
            {!ready && loadingPendingAccountAlert()}
            {ready && (
              <BlankProviderBill pendingAccountsCounter={totalElements} />
            )}
            {ready && totalElements !== 0 && <PendingAccountsAlert />}
          </>
        ) : (
          <Fragment>
            <Transactions fromProvider={true} className="col-lg-5" />
            {!ready && loadingPendingAccountAlert()}
            {ready && totalElements !== 0 && <PendingAccountsAlert />}
            <PieChart fromProvider={true} className="col-lg-3" />
          </Fragment>
        )}
      </div>
    </MainTemplate>
  );
};


export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    emptyBills: getEmptyBills(state),
  };
};

export default connect(mapStateToProps, null)(DashboardProvider);
